import styled from "styled-components";
import { Colors } from "../../styles/consts";

export const InfoDiv = styled.div`
display: flex;
justify-content: center;
`

export const TextContent = styled.p`

font-size: 30px;
font-weight: 700;
color: ${Colors.PRIMARY_COLOR_FONT};



`
export const ContainerText = styled.div`

display: flex;
align-items: center;

margin-bottom: 25px;
`
